import { TemplateRef } from "@angular/core";

export class TemplateModel {
    Index: number;
    Name: string;
    Template: TemplateRef<any>;
    Selected: boolean;

    constructor(index: number, name: string, template: TemplateRef<any>, selected = false) {
        this.Index = index;
        this.Name = name;
        this.Template = template;
        this.Selected = selected;
    }
}